import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index'),
    meta: {
      isIndex: true,
    },
  }, {
    path: '/job',
    name: 'job',
    component: () => import('@/views/job/index'),
    meta: {
      isIndex: true,
    },
  }, {
    path: '/mine',
    name: 'mine',
    component: () => import('@/views/mine/index'),
    meta: {
      isIndex: true,
    },
  }, {
    path: '/account/name-auth',
    name: 'name-auth',
    component: () => import('@/views/account/nameAuth'),
    meta: {
      needLogin: true,
    },
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/account/login'),
  }, {
    path: '/login/choice',
    name: 'choice',
    component: () => import('@/views/account/choice'),
  }, {
    path: '/mine/resume',
    name: 'resumeDetail',
    component: () => import('@/views/mine/resume'),
    meta: {
      needLogin: true,
      userType: [1],
    },
  }, {
    path: '/call-record',
    name: 'callRecord',
    component: () => import('@/views/mine/callRecord'),
    meta: {
      needLogin: true,
    },
  }, {
    path: '/view-record',
    name: 'viewRecord',
    component: () => import('@/views/mine/viewRecord'),
    meta: {
      needLogin: true,
    },
  }, {
    path: '/search/job',
    name: 'search-job',
    component: () => import('@/views/job/search'),
  }, {
    path: '/resume/newphone',
    name: 'newPhone',
    component: () => import('@/views/mine/newphone'),
    meta: {
      needLogin: true,
    },
  }, {
    path: "/job-map",
    name: 'map',
    component: () => import('@/views/job/map'),
  }, {
    path: "/resume",
    name: 'resume',
    component: () => import('@/views/resume/index'),
    meta: {
      isIndex: true,
    },
  }, {
    path: "/recruit/publish",
    name: 'servicePublish',
    component: () => import('@/views/recruit/publish'),
    meta: {
      needLogin: true,
      userType: [1, 2],
    },
  }, {
    path: "/service",
    name: 'service',
    component: () => import('@/views/mine/service'),
  }, {
    path: "/agreement",
    name: 'agreement',
    component: () => import('@/views/account/agreement'),
  }, {
    path: '/job/:id',
    name: 'job-id',
    component: () => import('@/views/job/detail'),
  }, {
    path: '/resume/:id',
    name: 'resume-id',
    component: () => import('@/views/resume/detail'),
  }, {
    path: "/privacypolicy",
    name: 'privacypolicy',
    component: () => import('@/views/account/privacypolicy'),
  }, {
    path: '/error',
    name: 'error',
    component: () => import('@/views/account/error'),
  }, {
    path: '/project/publish',
    name: 'oddPublish',
    component: () => import('@/views/project/publish'),
    meta: {
      needLogin: true,
      userType: [1, 2],
    },
  }, {
    path: '/project/manage',
    name: 'projectManage',
    component: () => import('@/views/project/manage'),
    meta: {
      needLogin: true,
      userType: [1, 2],
    },
  }, {
    path: '/service/manage',
    name: 'serviceManage',
    component: () => import('@/views/recruit/manage'),
    meta: {
      needLogin: true,
      userType: [1, 2],
    },
  },
  {
    path: '/account/company',
    name: "companyInfo",
    component: () => import('@/views/account/companyInfo'),
    meta: {
      needLogin: true,
      userType: [2],
    },
  }]

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/odd/' : '/',
  routes,
})

router.beforeEach((to, from, next) => {
  // 百度统计页面跟踪
  if (process.env.NODE_ENV === 'production') {
    window._hmt && window._hmt.push(['_trackPageview', to.fullPath]);
  }

  next()
})

export default router
